module.exports = __webpack_public_path__ + "static/media/workl-business-logo.9ed9adbf.png";